import { render, staticRenderFns } from "./RecuperaPw.vue?vue&type=template&id=da6a0874&scoped=true&"
import script from "./RecuperaPw.vue?vue&type=script&lang=js&"
export * from "./RecuperaPw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6a0874",
  null
  
)

export default component.exports